import { Component, OnInit } from '@angular/core';
import { SupplierService } from '../services/supplier.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WizardService } from '../../../shared/service/wizard.service';
import { Page } from 'src/app/shared/model/page';
import * as moment from 'moment/moment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ExtendsValidityComponent } from '../extends-validity/extends-validity.component';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-electricity-supplier',
  templateUrl: './electricity-supplier.component.html',
  styleUrls: ['./electricity-supplier.component.scss']
})
export class ElectricitySupplierComponent implements OnInit {
  public electricityContractSuppliers: Page<any>;
  public electricityContractNetworks: Page<any>;
  public contractSuppliersPageOffset = 0;
  public contractNetworkPageOffset = 0;
  public paginationSuppliersContract = [];
  public paginationNetworkContract = [];
  public contractSupplierForm: FormGroup;
  public contractNetworkForm: FormGroup;

  public contractNetworkSettings = {
    actions: {
      custom: [
        {
          name: 'places',
          title: '<p>Locuri asociate</p>'
        },
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    columns: {
      code: {
        title: 'CUI OR'
      },
      name: {
        title: 'Denumire OR'
      },
      contractNumber: {
        title: 'Numar'
      },
      date: {
        title: 'Data contract',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      // expirationDate: {
      //   title: 'Valabil pana la',
      //   valuePrepareFunction: (value) => new Date(value).toLocaleDateString("ro-RO")
      // },
    },
    hideSubHeader: true,
    sort: false,
  };
  public contractSupplierSettings = {
    actions: {
      custom: [
        {
          name: 'cancel',
          title: '<p class="action-c">Reziliaza</p>'
        },
        {
          name: 'removeCancel',
          title: '<p class="action-rc">Revoca reziliere</p>'
        },
        {
          name: 'sendIndex',
          title: '<p class="action-ti">Trimitere index</p>'
        },
        {
          name: 'extendsValidity',
          title: '<p class="action-pv">Prelungeste valabilitate</p>'
        },
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {
      let _class = '';
      if (row.data.status === 'ACTIV') {
        const today = moment().startOf('day');
        const startingDate = row.data.contractStartingDate && moment(row.data.contractStartingDate);
        const indexDate = row.data.indexDate ? moment(row.data.indexDate) : moment.unix(0);
        if (
          startingDate && today.diff(startingDate, 'days') === 0 &&
          indexDate && indexDate.diff(startingDate, 'days') < 0
        ) {
          _class += 'row_ACTIVE_TI';
        } else {
          _class += 'row_ACTIVE';
        }
      } else if (row.data.status === 'ACTIV (in curs de reziliere)') {
        _class = 'row_WITHDRAWN_PENDING ';
      } else if (row.data.status === 'ACTIV (neintrat in vigoare)') {
        _class = 'row_WITHDRAWN_UNENTERED ';
      } else {
        _class = 'row_DEFAULT ';
      }
      return _class;
    },
    columns: {
      clientCode: {
        title: 'CUI / CNP / Numar identificare'
      },
      client: {
        title: 'Client'
      },
      number: {
        title: 'Numar'
      },
      placeCode: {
        title: 'POD'
      },
      contractStartingDate: {
        title: 'Valabil de la',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      expirationDate: {
        title: 'Valabil pana la',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      status: {
        title: 'Status'
      },
      latestMessageId: {
        title: 'Message ID'
      }
    },
    hideSubHeader: true,
    sort: false,
  };

  constructor(
    private supplierService: SupplierService,
    private wizardService: WizardService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private toastrService: ToastrService
  ) {

  }

  initContractSupplierForm(): void {
    this.contractSupplierForm = this.formBuilder.group({
      clientCode: [''],
      clientName: [''],
      contractNumber: [''],
      placeCode: [''],
      contractStatus: [''],
    });
  }

  initContractNetworkForm(): void {
    this.contractNetworkForm = this.formBuilder.group({
      operatorCode: [''],
      operatorName: [''],
      contractNumber: [''],
    });
  }

  ngOnInit(): void {
    this.initContractSupplierForm();
    this.initContractNetworkForm();
    this.searchContractSuppliers();
    this.searchNetworkContracts();
  }

  searchNetworkContracts(): void {
    console.log('searchContractSuppliers', this.contractNetworkForm.getRawValue());
    this.supplierService.getSPElectricityNetworkContracts({
      pageOffset: this.contractNetworkPageOffset,
      filter: this.contractNetworkForm.getRawValue()
    }).subscribe(result => {
      this.electricityContractNetworks = result;
      this.contractNetworkPageOffset = result.number;
      this.paginationNetworkContract = [{ pageNumber: result.number, className: 'page-item active' }];
    });
  }

  searchContractSuppliers(): void {
    console.log('searchContractSuppliers', this.contractSupplierForm.getRawValue());
    this.supplierService.getSPElectricitySupplierContracts({
      pageOffset: this.contractSuppliersPageOffset,
      filter: this.contractSupplierForm.getRawValue()
    }).subscribe(result => {
      this.electricityContractSuppliers = result;
      this.contractSuppliersPageOffset = result.number;
      this.paginationSuppliersContract = [{ pageNumber: result.number, className: 'page-item active' }];
    });
  }

  onCustomActionContractSupplier(event: any): void {
    console.log(event);
    switch (event.action) {
      case 'sendIndex':
        this.router.navigate(['index'], {
          relativeTo: this.route, queryParams: {
            contractId: String(event.data.id),
            contractNumber: String(event.data.number),
            placeCode: String(event.data.placeCode),
          }
        });
        break;
      case 'cancel': {
        localStorage.setItem('contract', JSON.stringify(event.data));
        this.router.navigate(['furnizor', 'energie-electrica', 'inceteaza-contract'], { queryParams: { tip: 'energie-electrica' } });
        break;
      }
      case 'removeCancel': {
        this.supplierService.removeCancelContract(event.data.id).subscribe(e =>
          this.searchContractSuppliers()
        );
        break;
      }
      case 'extendsValidity': {
        const modalRef = this.modalService.open(ExtendsValidityComponent, { size: 'md' });
        modalRef.componentInstance.contract = event.data;
        modalRef.result.then((result) => {
          if (result === 'success') {
            this.ngOnInit();
            this.toastrService.success('Prelungirea valabilitatii a fost efectuata cu success');
          }
        }, (reason) => {
        });
      }
    }
  }

  openSupplierWizard(): void {
    this.wizardService.setWizardInformation({
      editable: 'true',
      fromSupplier: 'true',
      comparatorType: 'electric'
    });
    this.router.navigateByUrl('/furnizor/schimba-furnizor');
  }

  onCustomActionContractNetwork(event: any): void {
    console.log(event);
    switch (event.action) {
      case 'places': {
        this.router.navigate(['detalii-contract-de-retea'], {
          relativeTo: this.route,
          state: { networkContractId: event.data.id, editable: false }
        });
        break;
      }
    }
  }

  changeContractNetworkPage(page: any): void {
    this.contractNetworkPageOffset = page.pageNumber;
    this.searchNetworkContracts();
  }

  previousContractNetworkPage(): void {
    this.contractNetworkPageOffset = this.contractNetworkPageOffset === 0 ? 0 : this.contractNetworkPageOffset - 1;
    this.searchNetworkContracts();
  }

  nextContractNetworkPage(): void {
    this.contractNetworkPageOffset = this.contractNetworkPageOffset === this.electricityContractNetworks.totalPages - 1
      ? this.contractNetworkPageOffset : this.contractNetworkPageOffset + 1;
    this.searchNetworkContracts();
  }

  changeContractSuppliersPage(page: any): void {
    this.contractSuppliersPageOffset = page.pageNumber;
    this.searchContractSuppliers();
  }

  previousContractSuppliersPage(): void {
    this.contractSuppliersPageOffset = this.contractSuppliersPageOffset === 0 ? 0 : this.contractSuppliersPageOffset - 1;
    this.searchContractSuppliers();
  }

  nextContractSuppliersPage(): void {
    this.contractSuppliersPageOffset = this.contractSuppliersPageOffset === this.electricityContractSuppliers.totalPages - 1
      ? this.contractSuppliersPageOffset : this.contractSuppliersPageOffset + 1;
    this.searchContractSuppliers();
  }
}
